import { TextField, Paper, Grid2, Button, CircularProgress, Typography, Box, Backdrop, Autocomplete, IconButton, InputAdornment } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { useEffect, useState } from "react";
import { getLoggedInUser, updateUser, uploadProfilePicture } from "../services/auth";
import { enqueueSnackbar } from "notistack";
import { API_BASE_URL } from "../services/config";
import { getCities, getCountries, getStates } from "../services/country-data";
import PasswordUpdate from "../components/Profile/PasswordUpdate";
import LANGUAGES from '../static/data/languages.json';
import { Add, Close } from "@mui/icons-material";
import GoogleCalendarConnect from "../components/Profile/GoogleCalendarConnect";

const Profile = () => {

  const [details, set_details] = useState({
    name: '',
    contact_number: '',
    country: '',
    state: '',
    city: '',
    profile_url: null,
    bio : '',
    languages_spoken: [],
    issues_focused : [],
    accreditions : []
  })

  const [countries, set_countries] = useState([]);
  const [states, set_states] = useState([]);
  const [cities, set_cities] = useState([]);
  const [is_saving, set_is_saving] = useState(false);
  const [profile_file, set_profile_file] = useState(null);
  const [is_saving_profile_pic, set_is_saving_profile_pic] = useState(false);
  const [user_id, set_user_id] = useState('');
  const [user_email, set_user_email] = useState('');
  const [is_fetching_data, set_is_fetching_data] = useState(false);
  const [issue_value, set_issue_value] = useState('');
  const [accredition_value, set_accredition_value] = useState('');

  const getData = async () => {
    set_is_fetching_data(true);
    const { data } = await getLoggedInUser();
    set_is_fetching_data(false);

    if (data && data.success) {

      const country = data.data.country;
      const state = data.data.state;

      set_details({
        name: data.data.name,
        contact_number: data.data.contact_number,
        country: country,
        state: state,
        city: data.data.city,
        profile_url: data.data.profile_pic ? `${API_BASE_URL}/uploads/profile-pictures/${data.data.profile_pic}` : '',
        bio : data.data.bio || '',
        languages_spoken: data.data.languages_spoken || [],
        issues_focused: data.data.issues_focused || [],
        accreditions: data.data.accreditions || []
      });

      if(country){
        await getStatesData({
          country : country
        })

        if(state){
          getCityData({
            country : country,
            state : state
          })
        }
      }

      set_user_id(data.data._id);
      set_user_email(data.data.email)
    }
  }

  useEffect(() => {
    getData();
    getCountriesData();
    // eslint-disable-next-line
  }, [])

  const getCountriesData = async () => {
    const { data } = await getCountries();

    if (data) {
      set_countries(data.data);
    }
  }

  const getStatesData = async ({
    country
  }) => {
    set_is_fetching_data(true);

    const { data } = await getStates({
      country
    });

    set_is_fetching_data(false);
    if (data) {
      set_states(data.data);
    }
  }

  const getCityData = async ({
    country,
    state
  }) => {
    set_is_fetching_data(true);

    const { data } = await getCities({
      country : country,
      state : state
    });

    set_is_fetching_data(false);
    if (data) {
      set_cities(data.data);
    }
  }

  const handleDetailChange = (e) => {
    set_details({
      ...details,
      [e.target.name]: e.target.value
    })
  }

  const handleLanguageChange = (event, value) => {
    set_details({
      ...details,
      languages_spoken: value
    });
  }

  const handleSave = async () => {
    set_is_saving(true);

    const details_to_update = { ...details };

    delete details_to_update.profile_url;

    const { data } = await updateUser({
      data: details_to_update,
      id: user_id
    })

    set_is_saving(false);

    if (data && data.success) {
      enqueueSnackbar('Profile updated successfully !', {
        variant: 'success'
      })
    } else {
      enqueueSnackbar('Error while updating profile !', {
        variant: 'error'
      })
    }
  }

  const handleChangeProfileImage = (e) => {
    const file = e.target.files[0];

    if (file) {

      set_profile_file(file);

      const reader = new FileReader();

      reader.onloadend = () => {
        set_details({
          ...details,
          profile_url: reader.result
        })
      }

      reader.readAsDataURL(file)
    }
    e.target.value = ''
  }

  const handleUploadImage = async () => {
    set_is_saving_profile_pic(true);
    const formData = new FormData();

    formData.append('document', profile_file);

    const { data } = await uploadProfilePicture({
      data: formData
    });

    set_is_saving_profile_pic(false);

    if (data && data.success) {
      enqueueSnackbar('Profile picture updated successfully !', {
        variant: 'success'
      });

      getData();
      set_profile_file(null);
    } else {
      enqueueSnackbar('Error while updating profile picture !', {
        variant: 'error'
      });
    }
  }

  const handleChangeCountry = (event, value) => {
    set_details({
      ...details,
      country: value,
      state: '',
      city: ''
    });

    set_states([]);
    set_cities([]);

    getStatesData({
      country: value
    })
  }

  const handleChangeState = (event, value) => {
    set_details({
      ...details,
      state: value,
      city: ''
    });

    set_cities([]);

    getCityData({
      country : details.country,
      state: value
    })
  }

  const handleChangeCity = (event, value) => {
    set_details({
      ...details,
      city: value
    });
  }

  const handleAddItemToArray = (array_key, value) => {
    const _details = {...details}
    const selected_array = [..._details[array_key]]
    selected_array.push(value);

    _details[array_key] = selected_array;
    set_details(_details)
  }

  const handleRemoveItemFromArray = (array_key, index) => {
    const _details = {...details}
    const selected_array = [..._details[array_key]]
    selected_array.splice(index, 1);

    _details[array_key] = selected_array;
    set_details(_details)
  }
  const handleAddIssue = () => {
    const value_to_add = issue_value;
    if(Boolean(issue_value.trim())){
      handleAddItemToArray("issues_focused", value_to_add)
      set_issue_value('')
    }
  }

  const handleAddAccredition = () => {
    const value_to_add = accredition_value;
    if(Boolean(accredition_value.trim())){
      handleAddItemToArray("accreditions", value_to_add)
      set_accredition_value('')
    }
  }

  return (
    <Wrapper>

      <Backdrop
        open={is_fetching_data}
        sx={{ zIndex: '2100', color: '#fff' }}
        appear={true}
      >
        <CircularProgress
          color="inherit"
        />
      </Backdrop>

      <Grid2
        container
        spacing={3}
      >
        <Grid2
          size={3}
        >
          <Paper
            elevation={4}
            sx={{
              padding: '20px'
            }}
          >
            {
              details.profile_url ?
                <Box
                  display='flex'
                  justifyContent='center'
                >
                  <img
                    src={details.profile_url}
                    style={{
                      height: '150px',
                      width: '150px',
                      borderRadius: '50%'
                    }}
                    alt=''
                  />
                </Box> :
                <>
                  <Typography
                    display='flex'
                    height={50}
                    alignItems='center'
                    justifyContent='center'
                  >
                    Profile image not available
                  </Typography>
                </>
            }

            <Box
              component='div'
              display='flex'
              justifyContent='space-between'
              marginTop='20px'
            >
              <label>

                <input
                  type="file"
                  style={{
                    display: 'none'
                  }}
                  accept="image/jpg,image/png,image/jpeg"
                  onChange={handleChangeProfileImage}
                />
                <Button
                  component="span"
                  variant="outlined"
                  size="small"
                >
                  Choose Photo
                </Button>
              </label>

              <Button
                variant="contained"
                size="small"
                disabled={
                  is_saving_profile_pic ||
                  !Boolean(profile_file)
                }
                onClick={handleUploadImage}
              >
                {is_saving_profile_pic ? <CircularProgress color="#fff" size='20px' /> : 'Save'}
              </Button>

            </Box>
          </Paper>
        </Grid2>

        <Grid2
          size={3}
        >
          <PasswordUpdate />
        </Grid2>

        <Grid2
          size={6}
        >
          <GoogleCalendarConnect
            user_id = {user_id}
            user_email = {user_email}
          />
        </Grid2>
      </Grid2>
      <Paper
        elevation={4}
        sx={{
          padding: '20px',
          marginTop: '20px'
        }}
      >
        <Grid2
          container
          spacing={3}
        >
          <Grid2
            size={4}
          >
            <TextField
              variant="outlined"
              fullWidth
              label='Name'
              name="name"
              value={details.name}
              onChange={handleDetailChange}
            />
          </Grid2>

          <Grid2
            size={4}
          >
            <TextField
              variant="outlined"
              fullWidth
              label='Mobile Number'
              name="contact_number"
              value={details.contact_number}
              onChange={handleDetailChange}
            />
          </Grid2>

          <Grid2
            size = {4}
          >
            <Autocomplete
              options={LANGUAGES}
              multiple
              renderInput={(params) => <TextField {...params} label="Languages Spoken" />}
              onChange={handleLanguageChange}
              value={details.languages_spoken}
            />
          </Grid2>

          <Grid2
            size={4}
          >
            <Autocomplete
              options={countries}
              renderInput={(params) => <TextField {...params} label="Country" />}
              onChange={handleChangeCountry}
              value={details.country}
            />
          </Grid2>

          <Grid2
            size={4}
          >
            <Autocomplete
              options={states}
              renderInput={(params) => <TextField {...params} label="State" />}
              onChange={handleChangeState}
              value={details.state}
            />
          </Grid2>

          <Grid2
            size={4}
          >
            <Autocomplete
              options={cities}
              renderInput={(params) => <TextField {...params} label="City" />}
              onChange={handleChangeCity}
              value={details.city}
            />
          </Grid2>

          <Grid2
            size={12}
          >
            <TextField
              multiline
              rows={3}
              variant="outlined"
              fullWidth
              label='Bio'
              name="bio"
              value={details.bio}
              onChange={handleDetailChange}
            />
          </Grid2>

          <Grid2
            size={6}
          >
            <Typography
              variant="h6"
              marginBottom={"16px"}
            >
              Issues Focused
            </Typography>

            <TextField
              fullWidth
              label = "Issue"
              value={issue_value}
              onChange={(event) => set_issue_value(event.target.value)}
              slotProps={{
                input : {
                  endAdornment : (
                    <InputAdornment
                      position="end"
                    >
                      <IconButton
                        tabIndex={-1}
                        size="small"
                        color="primary"
                        onClick={handleAddIssue}
                        disabled = {!Boolean(issue_value.trim())}
                      >
                        <Add />
                      </IconButton>
                    </InputAdornment>
                  )
                }
              }}
            />

            <Box
              display="flex"
              flexWrap="wrap"
              border = "1px solid #ccc"
              padding="16px"
              gap="8px"
              marginTop="16px"
              borderRadius="4px"
            >
              {
                details.issues_focused.length === 0 &&
                <Typography
                  textAlign="center"
                  sx={{
                    width : "100%"
                  }}
                >
                  No items added
                </Typography>
              }
              {
                details.issues_focused.map((issue_item, index) => {
                  return(
                    <Box
                      display="flex"
                      alignItems="center"
                      gap="8px"
                      border="1px solid #ccc"
                      padding="8px"
                      borderRadius="5px"
                      key={`ISSUES-FOCUSED-${index}`}
                    >
                      <Typography
                        variant="body2"
                      >
                        {issue_item}
                      </Typography>

                      <Button
                        size="small"
                        sx={{
                          padding : "2px",
                          width : "auto",
                          minWidth : "0px"
                        }}
                        color="error"
                        onClick={() => handleRemoveItemFromArray("issues_focused", index)}
                      >
                        <Close
                          sx={{
                            height : "16px",
                            width : "16px"
                          }}
                        />
                      </Button>
                    </Box>
                  )
                })
              }
            </Box>
            
          </Grid2>

          <Grid2
            size={6}
          >
            <Typography
              variant="h6"
              marginBottom={"16px"}
            >
              Accreditions
            </Typography>

            <TextField
              fullWidth
              label = "Accredition"
              value={accredition_value}
              onChange={(event) => set_accredition_value(event.target.value)}
              slotProps={{
                input : {
                  endAdornment : (
                    <InputAdornment
                      position="end"
                    >
                      <IconButton
                        tabIndex={-1}
                        size="small"
                        color="primary"
                        onClick={handleAddAccredition}
                        disabled = {!Boolean(accredition_value.trim())}
                      >
                        <Add />
                      </IconButton>
                    </InputAdornment>
                  )
                }
              }}
            />

            <Box
              display="flex"
              flexDirection="column"
              border = "1px solid #ccc"
              padding="16px"
              gap="8px"
              marginTop="16px"
              borderRadius="4px"
            >
              {
                details.accreditions.length === 0 &&
                <Typography
                  textAlign="center"
                  sx={{
                    width : "100%"
                  }}
                >
                  No items added
                </Typography>
              }
              {
                details.accreditions.map((item, index) => {
                  return(
                    <Box
                      display="flex"
                      alignItems="center"
                      gap="8px"
                      border="1px solid #ccc"
                      padding="8px"
                      borderRadius="5px"
                      key={`ACCREDITION-${index}`}
                      justifyContent="space-between"
                    >
                      <Typography
                        variant="body2"
                      >
                        {item}
                      </Typography>

                      <Button
                        size="small"
                        sx={{
                          padding : "2px",
                          width : "auto",
                          minWidth : "0px"
                        }}
                        color="error"
                        onClick={() => handleRemoveItemFromArray("accreditions", index)}
                      >
                        <Close
                          sx={{
                            height : "16px",
                            width : "16px"
                          }}
                        />
                      </Button>
                    </Box>
                  )
                })
              }
            </Box>
          </Grid2>

        </Grid2>
      </Paper>

      <Paper
        elevation={4}
        sx={{
          padding: '10px 20px',
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px'
        }}
      >
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={
            is_saving ||
            !Boolean(details.name) ||
            !Boolean(details.contact_number) ||
            !Boolean(details.country) ||
            !Boolean(details.state) ||
            !Boolean(details.city) ||
            !Boolean(details.bio)
          }
        >
          {is_saving ? <CircularProgress color="#fff" size='20px' /> : 'Save'}
        </Button>
      </Paper>
    </Wrapper>
  )
}

export default Profile;